<template>
    <nav class="navbar app-navbar navbar-expand-lg navbar-light">
      <div class="container-fluid">
        <router-link class="navbar-brand" :to="homeLink">
          <img :src="branding.systemLogoUrl" :alt="branding.systemName" class="navbar-brand-logo" />
        </router-link>

        <button
          class="navbar-toggler"
          type="button"
          :aria-expanded="isNavbarExpanded ? 'true' : 'false'"
          @click="toggleMainNavbar"
          aria-controls="appMainNavbar"
          aria-label="Alternar navegación"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div
          id="appMainNavbar"
          class="collapse navbar-collapse"
          :class="{ show: isNavbarExpanded || !isMobileViewport }"
        >
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <!--
              Módulo SUSCRIPCIONES — el backoffice: QUÉ se cobra (D23).
              Cobrar NO está acá: vive en Operación, junto a caja, porque es
              trabajo del cajero y porque el operador ya tenía cobranza ahí.
            -->
            <li v-if="verSeccion('suscripciones')" class="nav-item dropdown" :class="{ show: isMobileDropdownOpen('suscripciones') }">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                :data-bs-toggle="isMobileViewport ? null : 'dropdown'"
                :aria-expanded="isMobileDropdownOpen('suscripciones') ? 'true' : 'false'"
                @click="handleDropdownToggle('suscripciones', $event)"
                title="Cobros recurrentes"
                data-test="menu-suscripciones"
              >
                <i class="bi bi-arrow-repeat"></i> <span class="nav-label">Suscripciones</span>
              </a>
              <ul class="dropdown-menu" :class="{ show: isMobileDropdownOpen('suscripciones') }">
                <li v-if="verItem('/suscripciones')">
                  <router-link class="dropdown-item" to="/suscripciones" @click="handleNavSelection">
                    <i class="bi bi-people"></i> Suscripciones
                  </router-link>
                </li>
                <li v-if="verItem('/suscripciones/lote')">
                  <router-link class="dropdown-item" to="/suscripciones/lote" @click="handleNavSelection">
                    <i class="bi bi-person-plus"></i> Inscribir varios
                  </router-link>
                </li>
                <li v-if="verItem('/suscripciones/esquemas') || verItem('/suscripciones/generacion') || verItem('/suscripciones/cargos')"><hr class="dropdown-divider"></li>
                <li v-if="verItem('/suscripciones/esquemas')">
                  <router-link class="dropdown-item" to="/suscripciones/esquemas" @click="handleNavSelection">
                    <i class="bi bi-diagram-3"></i> Esquemas de cobro
                  </router-link>
                </li>
                <li v-if="verItem('/suscripciones/generacion')">
                  <router-link class="dropdown-item" to="/suscripciones/generacion" @click="handleNavSelection">
                    <i class="bi bi-calendar-plus"></i> Generar períodos
                  </router-link>
                </li>
                <li v-if="verItem('/suscripciones/cargos')">
                  <router-link class="dropdown-item" to="/suscripciones/cargos" @click="handleNavSelection">
                    <i class="bi bi-receipt"></i> Cargos eventuales
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="verSeccion('operacion')" class="nav-item dropdown" :class="{ show: isMobileDropdownOpen('operacion') }">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                :data-bs-toggle="isMobileViewport ? null : 'dropdown'"
                :aria-expanded="isMobileDropdownOpen('operacion') ? 'true' : 'false'"
                @click="handleDropdownToggle('operacion', $event)"
                title="Operación"
                data-test="menu-operacion"
              >
                <i class="bi bi-lightning-charge"></i> <span class="nav-label">Operación</span>
              </a>
              <ul class="dropdown-menu" :class="{ show: isMobileDropdownOpen('operacion') }">
                <!--
                  `Ventas`, `Pedidos` y `E-Pedidos` salieron de acá (D24). En
                  este producto no se vende ni se pedidea por fuera del cobro:
                  lo que antes era una venta suelta ahora es un cobro con
                  productos y sin cuotas (RN-34). Se OCULTAN, no se desactivan
                  — las rutas y los permisos siguen vivos, porque son
                  compartidos con Caja y Facturación venta y revocarlos
                  arriesga funcionalidad que sí se usa. Esto no es una barrera
                  de seguridad: quien tenga el link sigue llegando.
                -->
                <li v-if="verItem('/cobranza')">
                  <router-link class="dropdown-item" to="/cobranza" @click="handleNavSelection">
                    <i class="bi bi-cash-stack"></i> Cobranza
                  </router-link>
                </li>
                <li v-if="verItem('/cobranza/estado-cuenta')">
                  <router-link class="dropdown-item" to="/cobranza/estado-cuenta" @click="handleNavSelection">
                    <i class="bi bi-person-lines-fill"></i> Estado de cuenta
                  </router-link>
                </li>
                <li v-if="verItem('/cobranza/cobros')">
                  <router-link class="dropdown-item" to="/cobranza/cobros" @click="handleNavSelection">
                    <i class="bi bi-receipt"></i> Cobros realizados
                  </router-link>
                </li>
                <li v-if="verItem('/cobranza/pendientes-facturar')">
                  <router-link class="dropdown-item" to="/cobranza/pendientes-facturar" @click="handleNavSelection">
                    <i class="bi bi-file-earmark-excel"></i> Pendientes de facturar
                  </router-link>
                </li>
                <li v-if="verItem('/cobranza') || verItem('/cobranza/cobros')"><hr class="dropdown-divider"></li>
                <li v-if="verItem('/caja')">
                  <router-link class="dropdown-item" to="/caja" @click="handleNavSelection">
                    <i class="bi bi-safe2"></i> Caja
                  </router-link>
                </li>
                <li v-if="verItem('/movimientos-caja')">
                  <router-link class="dropdown-item" to="/movimientos-caja" @click="handleNavSelection">
                    <i class="bi bi-arrow-left-right"></i> Movimientos caja
                  </router-link>
                </li>
                <li v-if="verItem('/cerrar-caja')">
                  <router-link class="dropdown-item" to="/cerrar-caja" @click="handleNavSelection">
                    <i class="bi bi-door-closed"></i> Cierre de caja
                  </router-link>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li v-if="verItem('/ventas-facturas')">
                  <router-link class="dropdown-item" to="/ventas-facturas" @click="handleNavSelection">
                    <i class="bi bi-receipt-cutoff"></i> Facturación venta
                  </router-link>
                </li>
                <li v-if="verItem('/cobro-factura-venta')">
                  <router-link class="dropdown-item" to="/cobro-factura-venta" @click="handleNavSelection">
                    <i class="bi bi-cash-stack"></i> Cobros factura
                  </router-link>
                </li>
                <li v-if="verItem('/notas-credito')">
                  <router-link class="dropdown-item" to="/notas-credito" data-test="nav-notas-credito"
                               @click="handleNavSelection">
                    <i class="bi bi-receipt-cutoff"></i> Notas de crédito
                  </router-link>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                  <a
                    class="dropdown-item"
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#searchProductModal"
                    @click="handleUtilityAction"
                  >
                    <i class="bi bi-search"></i> Buscar producto
                  </a>
                </li>
              </ul>
            </li>

            <li v-if="verSeccion('inventario')" class="nav-item dropdown admin-only" :class="{ show: isMobileDropdownOpen('inventario') }">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                :data-bs-toggle="isMobileViewport ? null : 'dropdown'"
                :aria-expanded="isMobileDropdownOpen('inventario') ? 'true' : 'false'"
                @click="handleDropdownToggle('inventario', $event)"
                data-test="menu-inventario"
                title="Catálogo e Inventario"
              >
                <i class="bi bi-box-seam"></i> <span class="nav-label">Inventario</span>
              </a>
              <ul class="dropdown-menu" :class="{ show: isMobileDropdownOpen('inventario') }">
                <li v-if="verItem('/inventario')">
                  <router-link class="dropdown-item" to="/inventario" @click="handleNavSelection">
                    <i class="bi bi-speedometer2"></i> Stock / Dashboard
                  </router-link>
                </li>
                <li v-if="verItem('/inventario/productos')">
                  <router-link class="dropdown-item" to="/inventario/productos" @click="handleNavSelection">
                    <i class="bi bi-box"></i> Productos
                  </router-link>
                </li>
                <li v-if="verItem('/inventario/productos-precio')">
                  <router-link class="dropdown-item" to="/inventario/productos-precio" @click="handleNavSelection">
                    <i class="bi bi-tags"></i> Precios
                  </router-link>
                </li>
                <li v-if="verItem('/inventario/grupos-precio')">
                  <router-link class="dropdown-item" to="/inventario/grupos-precio" @click="handleNavSelection">
                    <i class="bi bi-collection"></i> Grupos de precio
                  </router-link>
                </li>
                <li v-if="verItem('/inventario/presentaciones')">
                  <router-link class="dropdown-item" to="/inventario/presentaciones" @click="handleNavSelection">
                    <i class="bi bi-boxes"></i> Presentaciones
                  </router-link>
                </li>
                <li v-if="verItem('/inventario/categorias')">
                  <router-link class="dropdown-item" to="/inventario/categorias" @click="handleNavSelection">
                    <i class="bi bi-bookmark"></i> Categorías
                  </router-link>
                </li>
                <li v-if="verItem('/inventario/unidades-medida')">
                  <router-link class="dropdown-item" to="/inventario/unidades-medida" @click="handleNavSelection">
                    <i class="bi bi-rulers"></i> Unidades de medida
                  </router-link>
                </li>
                <li v-if="verItem('/inventario/movimientos')">
                  <router-link class="dropdown-item" to="/inventario/movimientos" @click="handleNavSelection">
                    <i class="bi bi-arrow-left-right"></i> Movimientos
                  </router-link>
                </li>
                <li v-if="verItem('/inventario/lotes')">
                  <router-link class="dropdown-item" to="/inventario/lotes" @click="handleNavSelection">
                    <i class="bi bi-box2"></i> Lotes
                  </router-link>
                </li>
                <li v-if="verItem('/inventario/depositos')">
                  <router-link class="dropdown-item" to="/inventario/depositos" @click="handleNavSelection">
                    <i class="bi bi-building"></i> Depósitos
                  </router-link>
                </li>
                <li v-if="verItem('/inventario/control')">
                  <router-link class="dropdown-item" to="/inventario/control" @click="handleNavSelection">
                    <i class="bi bi-clipboard-check"></i> Control de inventario
                  </router-link>
                </li>
              </ul>
            </li>

            <li v-if="verSeccion('compras')" class="nav-item dropdown" :class="{ show: isMobileDropdownOpen('compras') }">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                :data-bs-toggle="isMobileViewport ? null : 'dropdown'"
                :aria-expanded="isMobileDropdownOpen('compras') ? 'true' : 'false'"
                @click="handleDropdownToggle('compras', $event)"
                data-test="menu-compras"
                title="Compras"
              >
                <i class="bi bi-basket"></i> <span class="nav-label">Compras</span>
              </a>
              <ul class="dropdown-menu" :class="{ show: isMobileDropdownOpen('compras') }">
                <li v-if="verItem('/listar-proveedores')">
                  <router-link class="dropdown-item" to="/listar-proveedores" @click="handleNavSelection">
                    <i class="bi bi-truck"></i> Proveedores
                  </router-link>
                </li>
                <li v-if="verItem('/listar-notas-remision')">
                  <router-link class="dropdown-item" to="/listar-notas-remision" @click="handleNavSelection">
                    <i class="bi bi-file-text"></i> Notas de Remisión
                  </router-link>
                </li>
                <li v-if="verItem('/listar-comprobantes')">
                  <router-link class="dropdown-item" to="/listar-comprobantes" @click="handleNavSelection">
                    <i class="bi bi-receipt"></i> Facturas Compras
                  </router-link>
                </li>
              </ul>
            </li>

            <li v-if="verSeccion('clientes')" class="nav-item dropdown" :class="{ show: isMobileDropdownOpen('clientes') }">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                :data-bs-toggle="isMobileViewport ? null : 'dropdown'"
                :aria-expanded="isMobileDropdownOpen('clientes') ? 'true' : 'false'"
                @click="handleDropdownToggle('clientes', $event)"
                data-test="menu-clientes"
                title="Clientes"
              >
                <i class="bi bi-people"></i> <span class="nav-label">Clientes</span>
              </a>
              <ul class="dropdown-menu" :class="{ show: isMobileDropdownOpen('clientes') }">
                <li v-if="verItem('/clientes')">
                  <router-link class="dropdown-item" to="/clientes" @click="handleNavSelection">
                    <i class="bi bi-person-lines-fill"></i> Clientes
                  </router-link>
                </li>
                <li v-if="verItem('/clientes/creditos')">
                  <router-link class="dropdown-item" to="/clientes/creditos" @click="handleNavSelection">
                    <i class="bi bi-wallet2"></i> Créditos
                  </router-link>
                </li>
                <li v-if="verItem('/cobro-cliente-credito')">
                  <router-link class="dropdown-item" to="/cobro-cliente-credito" @click="handleNavSelection">
                    <i class="bi bi-cash"></i> Cobros a crédito
                  </router-link>
                </li>
              </ul>
            </li>

            <li v-if="verSeccion('administracion')" class="nav-item dropdown admin-only" :class="{ show: isMobileDropdownOpen('administracion') }">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                :data-bs-toggle="isMobileViewport ? null : 'dropdown'"
                :aria-expanded="isMobileDropdownOpen('administracion') ? 'true' : 'false'"
                @click="handleDropdownToggle('administracion', $event)"
                data-test="menu-administracion"
                title="Administración"
              >
                <i class="bi bi-sliders"></i> <span class="nav-label">Admin.</span>
              </a>
              <ul class="dropdown-menu" :class="{ show: isMobileDropdownOpen('administracion') }">
                <li v-if="verItem('/mantenimiento')">
                  <router-link class="dropdown-item" to="/mantenimiento" @click="handleNavSelection">
                    <i class="bi bi-grid-1x2"></i> Resumen mantenimiento
                  </router-link>
                </li>
                  <li v-if="verItem('/mantenimiento/operativo')">
                    <router-link class="dropdown-item" to="/mantenimiento/operativo" @click="handleNavSelection">
                      <i class="bi bi-sliders"></i> Mantenimiento operativo
                    </router-link>
                  </li>
                  <li v-if="verItem('/mantenimiento/balanzas')">
                    <router-link class="dropdown-item" to="/mantenimiento/balanzas" @click="handleNavSelection">
                      <i class="bi bi-upc-scan"></i> Balanzas
                    </router-link>
                  </li>
                  <li v-if="verItem('/mantenimiento/fiscal')">
                    <router-link class="dropdown-item" to="/mantenimiento/fiscal" @click="handleNavSelection">
                      <i class="bi bi-receipt-cutoff"></i> Mantenimiento fiscal
                    </router-link>
                  </li>
                <li v-if="verItem('/mantenimiento/fiscal/points')">
                  <router-link class="dropdown-item" to="/mantenimiento/fiscal/points" @click="handleNavSelection">
                    <i class="bi bi-diagram-3"></i> Puntos
                  </router-link>
                </li>
                <li v-if="verItem('/mantenimiento/fiscal/timbrados')">
                  <router-link class="dropdown-item" to="/mantenimiento/fiscal/timbrados" @click="handleNavSelection">
                    <i class="bi bi-journal-text"></i> Timbrados
                  </router-link>
                </li>
                <li v-if="verItem('/mantenimiento/fiscal/series')">
                  <router-link class="dropdown-item" to="/mantenimiento/fiscal/series" @click="handleNavSelection">
                    <i class="bi bi-123"></i> Series
                  </router-link>
                </li>
                <li v-if="verItem('/mantenimiento/cajas')">
                  <router-link class="dropdown-item" to="/mantenimiento/cajas" @click="handleNavSelection">
                    <i class="bi bi-safe2"></i> Cajas
                  </router-link>
                </li>
              </ul>
            </li>

            <li v-if="verSeccion('seguridad')" class="nav-item dropdown admin-only" :class="{ show: isMobileDropdownOpen('seguridad') }">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                :data-bs-toggle="isMobileViewport ? null : 'dropdown'"
                :aria-expanded="isMobileDropdownOpen('seguridad') ? 'true' : 'false'"
                @click="handleDropdownToggle('seguridad', $event)"
                data-test="menu-seguridad"
                title="Seguridad y Personal"
              >
                <i class="bi bi-shield-lock"></i> <span class="nav-label">Seguridad</span>
              </a>
              <ul class="dropdown-menu" :class="{ show: isMobileDropdownOpen('seguridad') }">
                <li v-if="verItem('/user-management')">
                  <router-link class="dropdown-item" to="/user-management" @click="handleNavSelection">
                    <i class="bi bi-person-gear"></i> Gestión de usuarios
                  </router-link>
                </li>
                <li v-if="verItem('/roles')">
                  <router-link class="dropdown-item" to="/roles" @click="handleNavSelection">
                    <i class="bi bi-person-badge"></i> Roles
                  </router-link>
                </li>
                <li v-if="verItem('/permisos')">
                  <router-link class="dropdown-item" to="/permisos" @click="handleNavSelection">
                    <i class="bi bi-key"></i> Permisos
                  </router-link>
                </li>
              </ul>
            </li>
            <!--
              Ecommerce SE OCULTA del menú (D-R6, con el patrón de D24): no hay
              storefront en este producto — `ecommerce-graciela` no se copió
              (AGENTS.md 0.1) — y aun así lo veían cuatro de los ocho roles.
              La ruta `/ecommerce`, sus permisos y sus pantallas **siguen
              vivos**: ocultar no es desactivar, y volver a mostrarlo es
              agregarlo a `menuModules.mjs`. Por eso tampoco se declara como
              sección con una bandera: un módulo oculto que sigue declarado es
              una invitación a reactivarlo sin leer por qué se ocultó.
            -->
            <li v-if="verSeccion('reportes')" class="nav-item">
              <router-link class="nav-link" to="/reportes" title="Reportes" data-test="menu-reportes" @click="handleNavSelection">
                <i class="bi bi-bar-chart"></i> <span class="nav-label">Reportes</span>
              </router-link>
            </li>
          </ul>

          <div v-if="showSucursalSelector" class="navbar-sucursal-selector me-3">
            <label class="navbar-sucursal-label" for="navbarSucursalSelect">Cambiar establecimiento</label>
            <select
              id="navbarSucursalSelect"
              class="form-select form-select-sm navbar-sucursal-select"
              :value="currentSucursalId || ''"
              @change="handleSucursalChange"
            >
              <option v-for="sucursal in assignedSucursales" :key="'navbar-sucursal-'+sucursal.sucursal_id" :value="sucursal.sucursal_id">
                {{ resolveSucursalLabel(sucursal) }}
              </option>
            </select>
          </div>

          <div ref="accountMenu" class="navbar-account nav-item position-relative">
            <!-- Disparador del menú de cuenta. Es un <button> y no un <span>
                 con @click: antes no era alcanzable por teclado (sin role ni
                 tabindex), así que cerrar sesión sólo se podía con el mouse.
                 El chevron indica que despliega algo — antes nada sugería
                 que fuera clickeable. -->
            <button
              type="button"
              class="btn btn-link navbar-account-toggle p-0 border-0"
              :aria-expanded="showMenu ? 'true' : 'false'"
              aria-haspopup="menu"
              :title="clientTradeName || branding.systemName"
              @click="toggleMenu"
            >
              <span class="navbar-text client-trade-name">
                {{ clientTradeName || branding.systemName }}
              </span>
              <i class="bi bi-chevron-down navbar-account-caret" :class="{ 'is-open': showMenu }"></i>
            </button>

            <div v-if="showMenu" class="position-absolute p-2 border border-light rounded navbar-account-menu" role="menu" style="right: 0; top: 100%; background-color: black; z-index: 1050;">
              <button type="button" role="menuitem" class="btn btn-link text-white p-0 border-0" @click="cerrarSesion">Cerrar Sesión</button>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <!-- Modal Buscar Producto -->
    <div
      class="modal fade"
      id="searchProductModal"
      tabindex="-1"
      aria-labelledby="searchProductModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="searchProductModalLabel">Buscar Producto</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="productCodeSearch" class="form-label">Código de Barras</label>
              <input
                id="productCodeSearch"
                type="text"
                class="form-control"
                v-model="productCodeSearch"
                @keydown.enter.prevent="buscarProducto"
                placeholder="Ingresa el código de barras"
              />
            </div>
            <div id="searchResult" class="mt-3" v-html="searchResult"></div>
          </div>
          <div class="modal-footer">
            <!-- Botones que antes estaban en #footer -->
            <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal" @click="clearSearchForm">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="buscarProducto">Buscar</button>
          </div>
        </div>
      </div>
    </div>






</template>
  
<script>
// Agregar al inicio del script
import apiService from '../services/apiService.js';
import {
  clearAuthSession,
  getAssignedSucursales,
  getCurrentSucursalIdFromSession,
  hasPermission,
  setCurrentSucursalId
} from '../services/authSessionService';
import operationalContextService from '@/services/operationalContextService';
import brandingService from '@/services/brandingService';
import { MENU, itemVisible, seccionesVisibles } from '@/constants/menuModules.mjs';
import { homeDestino } from '@/router/homeDestino.mjs';
import pedidoOnlineService from '@/services/pedidoOnlineService';

export default {
    name: 'AppNavbar',
    // Added data properties:
    data() {
      return {
        isMobileViewport: false,
        isNavbarExpanded: false,
        mobileOpenDropdown: null,
        productCodeSearch: '',
        productNameSearch: '',
        searchResult: '',
        showMenu: false,
        assignedSucursales: [],
        currentSucursalId: null,
        availableSucursalCatalog: [],
        branding: brandingService.getSystemBranding(),
        commercialBranding: brandingService.getDefaultCommercialBranding(),
        clientTradeName: "",
        pedidosWebPendientesCount: 0
      };
    },
    computed: {
      // El menú entero se deriva de `menuModules.mjs` (PLAN 1.2). Antes había
      // una `computed` por sección y otra por ítem —39 en total— y la relación
      // «una sección se ve si alguno de sus ítems se ve» no vivía en ningún
      // lado: por eso «Operación» era el único `<li>` sin `v-if` y se abría
      // vacío para cuatro roles (A-2), y siete de los ocho ítems de «Admin.»
      // tampoco tenían gate (A-12). Ahora eso se calcula, así que no puede
      // volver a olvidarse.
      seccionesVisiblesSet() {
        return seccionesVisibles(hasPermission);
      },
      itemsVisiblesSet() {
        const visibles = new Set();
        for (const seccion of MENU) {
          for (const item of seccion.items) {
            if (itemVisible(item, hasPermission)) visibles.add(item.href);
          }
        }
        return visibles;
      },
      canManageEcommerce() {
        return hasPermission('gestionar_ecommerce');
      },
      // E3: cobrar ES trabajo del cajero, y ver lo que cobro tambien.
      canCobrarDeudas() {
        return hasPermission('cobrar_deudas');
      },
      // `canViewPedidos` se eliminó con D24: gateaba el ítem `Pedidos`, que
      // ya no está en ningún menú. El permiso `ver_pedidos_pendientes` sigue
      // existiendo y la ruta sigue viva — lo que se fue es la puerta, no la
      // habitación.
      //
      canViewReportes() {
        return hasPermission('ver_reportes');
      },
      // Home por rol (RF-2 de SPEC_DASHBOARD_GERENCIAL_v0.1.md): mismo
      // criterio que el redirect de login.
      homeLink() {
        // Una sola función para los tres lugares que decidían esto (A-8).
        return homeDestino(hasPermission);
      },
      showSucursalSelector() {
        return this.assignedSucursales.length > 1;
      }
    },
    watch: {
      $route() {
        this.closeMainNavbar();
        this.showMenu = false;
      }
    },
    mounted() {
      this.loadCommercialBranding();
      this.loadSucursalContext();
      this.syncViewportState();
      window.addEventListener('resize', this.syncViewportState);
      window.addEventListener('app:close-mobile-nav', this.closeMainNavbar);
      window.addEventListener('storage', this.syncSucursalFromStorage);
      // El menú de cuenta quedaba abierto al hacer clic en cualquier otro
      // lado y no respondía a Escape: había que volver a clickear el nombre
      // para cerrarlo. Ambos son el comportamiento esperado de cualquier
      // menú y su ausencia se notaba enseguida al usarlo.
      document.addEventListener('click', this.handleAccountOutsideClick);
      document.addEventListener('keydown', this.handleAccountKeydown);
      if (this.canManageEcommerce) {
        this.loadPedidosWebPendientesCount();
      }
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.syncViewportState);
      window.removeEventListener('app:close-mobile-nav', this.closeMainNavbar);
      window.removeEventListener('storage', this.syncSucursalFromStorage);
      document.removeEventListener('click', this.handleAccountOutsideClick);
      document.removeEventListener('keydown', this.handleAccountKeydown);
    },
    methods: {
      hasPermission,
      // Un href que no está en `MENU` da `false`: es lo que oculta a Ecommerce
      // y a Balanzas sin necesidad de una bandera (ver `OCULTOS`).
      verSeccion(id) {
        return this.seccionesVisiblesSet.has(id);
      },
      verItem(href) {
        return this.itemsVisiblesSet.has(href);
      },
      async loadPedidosWebPendientesCount() {
        try {
          this.pedidosWebPendientesCount = await pedidoOnlineService.countPendientes();
        } catch (_) {
          this.pedidosWebPendientesCount = 0;
        }
      },
      async loadCommercialBranding() {
        try {
          this.commercialBranding = await brandingService.getPublicBranding();
          this.refreshClientTradeName();
        } catch (_) {
          this.commercialBranding = brandingService.getDefaultCommercialBranding();
        }
      },
      async loadSucursalContext() {
        this.assignedSucursales = Array.isArray(getAssignedSucursales()) ? getAssignedSucursales() : [];
        this.currentSucursalId = getCurrentSucursalIdFromSession();

        if (!this.currentSucursalId && this.assignedSucursales.length) {
          const preferred = this.assignedSucursales.find((item) => item.predeterminada) || this.assignedSucursales[0];
          if (preferred?.sucursal_id) {
            setCurrentSucursalId(preferred.sucursal_id);
            this.currentSucursalId = Number(preferred.sucursal_id);
          }
        }

        if (this.assignedSucursales.length) {
          try {
            const catalog = await operationalContextService.listSucursales();
            this.availableSucursalCatalog = Array.isArray(catalog) ? catalog : [];
          } catch (_) {
            this.availableSucursalCatalog = [];
          }
        }

        this.refreshClientTradeName();
      },

      refreshClientTradeName() {
        const current = this.assignedSucursales.find((item) => Number(item?.sucursal_id) === Number(this.currentSucursalId));
        const fallback = current ? this.resolveSucursalLabel(current) : "";
        const sucursalName = brandingService.resolveClientTradeName(current, fallback);
        this.clientTradeName = brandingService.resolveCommerceAndSucursalName(
          this.commercialBranding.commerceName,
          sucursalName
        );
      },
      syncSucursalFromStorage() {
        this.currentSucursalId = getCurrentSucursalIdFromSession();
        this.refreshClientTradeName();
      },
      resolveSucursalLabel(sucursal) {
        const sucursalId = Number(sucursal?.sucursal_id);
        const match = this.availableSucursalCatalog.find((item) => Number(item?.sucursal_id) === sucursalId);
        return match?.nombre_establecimiento || `Sucursal ${sucursalId}`;
      },
      async handleSucursalChange(event) {
        const nextSucursalId = Number(event?.target?.value || 0);
        const previousSucursalId = Number(this.currentSucursalId || 0);
        if (previousSucursalId && previousSucursalId !== nextSucursalId) {
          // `await`: `window.confirm` es el diálogo de la app y devuelve una PROMESA;
          // sin esperarla, «Cancelar» no cancelaba (FIX_HALLAZGOS_DE_VERIFICACION, F-2).
          const confirmed = await window.confirm('Cambiar de establecimiento limpia el contexto operativo actual. Si tiene una caja abierta en el establecimiento anterior, deberá cerrarla desde Caja antes de operar caja en el nuevo establecimiento. ¿Desea continuar?');
          if (!confirmed) {
            event.target.value = String(previousSucursalId);
            return;
          }
        }
        if (!setCurrentSucursalId(nextSucursalId)) {
          const message = 'No tiene permisos para operar en el establecimiento seleccionado.';
          if (window.alert?.error) {
            window.alert.error(message);
          } else {
            window.alert(message);
          }
          return;
        }
        this.currentSucursalId = nextSucursalId;
        this.refreshClientTradeName();
        window.dispatchEvent(new CustomEvent('app:sucursal-changed', {
          detail: {
            sucursal_id: nextSucursalId,
            previous_sucursal_id: previousSucursalId || null
          }
        }));
        this.handleNavSelection();
      },
      syncViewportState() {
        this.isMobileViewport = window.innerWidth < 992;
        if (!this.isMobileViewport) {
          this.mobileOpenDropdown = null;
          this.isNavbarExpanded = false;
        }
      },
      toggleMainNavbar() {
        if (this.isNavbarExpanded) {
          this.closeMainNavbar();
          return;
        }
        this.mobileOpenDropdown = null;
        this.isNavbarExpanded = true;
        window.dispatchEvent(new CustomEvent('app:close-inventory-sidebar'));
      },
      closeMainNavbar() {
        this.mobileOpenDropdown = null;
        this.isNavbarExpanded = false;
      },
      isMobileDropdownOpen(section) {
        return this.isMobileViewport && this.mobileOpenDropdown === section;
      },
      handleDropdownToggle(section, event) {
        if (!this.isMobileViewport) return;
        event.preventDefault();
        if (!this.isNavbarExpanded) {
          this.toggleMainNavbar();
        }
        this.mobileOpenDropdown = this.mobileOpenDropdown === section ? null : section;
      },
      handleNavSelection() {
        if (this.isMobileViewport) {
          this.closeMainNavbar();
        }
      },
      handleUtilityAction() {
        if (this.isMobileViewport) {
          this.closeMainNavbar();
        }
      },
      // Reemplazar el método buscarProducto en “methods”
      async buscarProducto() {
        this.searchResult = '';
        const codigo = this.productCodeSearch.trim();
        if (!codigo) {
          this.searchResult = '<div class="alert alert-warning">Por favor, ingresa el código de barras.</div>';
          return;
        }
        try {
          const url = `${process.env.VUE_APP_API_BASE_URL}/api/products/barcode/${codigo}`;
          const response = await apiService.get(url);
          const producto = response.data;
          console.log("Producto encontrado:", producto);
          if (producto && producto.producto_id) {
            // Aquí puedes agregar la lógica para mostrar el producto encontrado
            this.searchResult = `
              <div class="alert alert-success">
                <strong>Producto encontrado:</strong><br>
                <strong>Nombre:</strong> ${producto.nombre}<br>
                <strong>Categoría:</strong> ${producto.categoria_nombre}<br>
                <strong>Descripción:</strong> ${producto.descripcion ?? '—'}<br>
                <strong>Disponibilidad:</strong> ${producto.stock_disponible > 0 ? 'Disponible' : 'Sin stock'}<br>
                <strong>Precio:</strong> ${this.formateaNumero(producto.precio_unitario_resuelto ?? 0)} ₲<br>
                <strong>Unidad de Medida:</strong> ${producto.unidad_medida_nombre}<br>
                <strong>IVA:</strong> ${this.formateaNumero(producto.porcentaje_iva)}%<br>

              </div>`;
          } else {
            this.searchResult = '<div class="alert alert-danger">Producto no encontrado.</div>';
          }
        } catch (e) {
          console.error("Error al obtener el producto:", e);
          this.searchResult = '<div class="alert alert-danger">Error al buscar el producto.</div>';
        }
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      handleAccountOutsideClick(event) {
        if (!this.showMenu) return;
        const contenedor = this.$refs.accountMenu;
        // El clic sobre el propio disparador lo maneja toggleMenu; si acá
        // también lo cerráramos, el menú se abriría y cerraría en el mismo
        // clic y nunca llegaría a verse.
        if (contenedor && contenedor.contains(event.target)) return;
        this.showMenu = false;
      },
      handleAccountKeydown(event) {
        if (event.key !== 'Escape' || !this.showMenu) return;
        this.showMenu = false;
        // Devuelve el foco al disparador: si no, tras cerrar con Escape el
        // foco queda huérfano en el body y el siguiente Tab arranca desde
        // el principio de la página.
        this.$refs.accountMenu?.querySelector('.navbar-account-toggle')?.focus();
      },
      clearSearchForm() {
        this.productCodeSearch = '';
        this.searchResult      = '';
      },
      formatCurrency(value) {
        return new Intl.NumberFormat("es-ES", {
          style: "currency",
          currency: "USD"
        }).format(Math.round(Number(value || 0)));
      },
      formateaNumero(n) {
        if (n === null || n === undefined) return '';
        return Number(Math.round(n)).toLocaleString('es-PY', { minimumFractionDigits: 0 });
      },
      cerrarSesion() {
        // Lógica de cierre de sesión: remover token, rol, etc.
        clearAuthSession();
        this.$router.push("/"); // O la ruta que desees al cerrar sesión
      }
    },
  };

</script>
  
<style scoped>
  :global(:root) {
    --app-mobile-navbar-height: 56px;
  }

  .app-navbar {
    background-color: #ffffff;
    border-bottom: 1px solid rgba(19, 47, 58, 0.12);
    box-shadow: 0 6px 20px rgba(19, 47, 58, 0.08);
    position: relative;
    z-index: 1030; /* Above page content, below modals/overlays */
    min-height: var(--app-mobile-navbar-height);
  }
  
  .navbar-brand-logo {
    height: 32px;
    width: auto;
    display: block;
  }
  
  .navbar-nav .nav-link {
    font-size: 1rem;
    margin-right: 10px;
  }
  
  .navbar-nav .dropdown-menu {
    background-color: #ffffff;
    border: 1px solid rgba(19, 47, 58, 0.12);
    box-shadow: 0 12px 26px rgba(19, 47, 58, 0.16);
    min-width: 14rem;
    margin-top: 0;
    z-index: 1040;
  }

  .navbar-nav .dropdown-item {
    color: #132f3a;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-height: 38px;
  }

  .navbar-nav .dropdown-item:hover,
  .navbar-nav .dropdown-item:focus {
    background-color: rgba(7, 167, 225, 0.08);
    color: #07a7e1;
  }

  .navbar-nav .dropdown-item.router-link-active,
  .navbar-nav .dropdown-item.router-link-exact-active {
    color: #07a7e1;
    font-weight: 600;
    background-color: rgba(7, 167, 225, 0.07);
  }

  .navbar-nav .dropdown-toggle::after {
    margin-left: 0.35rem;
  }

  .navbar-text.client-trade-name {
    font-size: 1.1rem;
    font-weight: 600;
    color: #132f3a;
    /* Sin esto el nombre del comercio se parte en hasta 5 líneas y estira la
       navbar de 59px a 123px (medido a 1440px con "COMERCIAL GRACIELA ·
       Establecimiento 001"). El nombre completo queda en el `title`, así que
       truncar no esconde información: se ve al pasar el mouse. */
    display: inline-block;
    max-width: 22ch;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  /* Modo ícono SOLO en el navbar horizontal de escritorio, donde el menú
     completo no entra. 8 grupos de primer nivel suman ~1280px; con el logo y
     el bloque de cuenta, por debajo de ~1400px el `.navbar-collapse`
     desbordaba horizontalmente (188px a 1440px, 348px a 1280px).
     Se oculta solo la etiqueta del PRIMER nivel: los nombres siguen visibles
     al desplegar cada menú, y el `title` los muestra al pasar el mouse, así
     que no se pierde descubribilidad.

     Acotado a `min-width: 992px` (hallazgo real, verificado en un celular
     2026-08-15): sin ese piso, la regla también se aplicaba en todo el rango
     mobile (`navbar-expand-lg` colapsa a la barra lateral vertical por
     debajo de 992px, ver el bloque `@media (max-width: 991.98px)` más abajo)
     — el menú lateral oscuro quedaba con íconos y sin ningún nombre de
     módulo, y ahí no hay mouse para el `title` que compensa en escritorio.
     La medición original (navbar-densidad-y-menu-cuenta.md) sólo cubrió el
     rango 1180–1400px de escritorio, nunca por debajo de 992px. */
  @media (min-width: 992px) and (max-width: 1400px) {
    .navbar-nav > .nav-item > .nav-link .nav-label {
      display: none;
    }

    .navbar-nav > .nav-item > .nav-link i {
      font-size: 1.15rem;
    }
  }

    .navbar-brand,
    .navbar-nav .nav-link,
    .navbar-text.client-trade-name {
    color: #132f3a !important;
    font-weight: bold;
  }

  .navbar-account {
    list-style: none;
  }

  .navbar-account-toggle {
    display: inline-flex;
    align-items: center;
    gap: .4rem;
    text-decoration: none;
    max-width: 100%;
  }

  .navbar-account-toggle:hover .client-trade-name {
    text-decoration: underline;
  }

  .navbar-account-caret {
    font-size: .75rem;
    transition: transform .15s ease;
    flex-shrink: 0;
  }

  .navbar-account-caret.is-open {
    transform: rotate(180deg);
  }

  .navbar-sucursal-selector {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .navbar-sucursal-label {
    color: #132f3a;
    font-size: 0.85rem;
    font-weight: 600;
    margin: 0;
  }

  .navbar-sucursal-select {
    min-width: 180px;
    background: #f7fbfd;
    border-color: rgba(19, 47, 58, 0.16);
    color: #132f3a;
  }

  .navbar-sucursal-select:focus {
    border-color: #07a7e1;
    box-shadow: 0 0 0 0.2rem rgba(7, 167, 225, 0.14);
  }

  .navbar-sucursal-select option {
    color: #111;
  }

  @media (min-width: 992px) {
    .navbar-nav .dropdown:hover > .dropdown-menu,
    .navbar-nav .dropdown:focus-within > .dropdown-menu {
      display: block;
    }

    .navbar-nav .dropdown:hover > .nav-link,
    .navbar-nav .dropdown:focus-within > .nav-link {
      color: #07a7e1;
    }
  }

  @media (max-width: 991.98px) {
    .navbar {
      position: sticky;
      top: 0;
      z-index: 1060;
    }

    .navbar-collapse {
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
      max-height: calc(100vh - 56px);
      overflow-y: auto;
      background: #343a40;
      color: #f8fafc;
    }

    .navbar-nav .nav-link {
      color: #f8fafc !important;
      margin-right: 0;
      padding-top: 0.875rem;
      padding-bottom: 0.875rem;
      min-height: 48px;
      display: flex;
      align-items: center;
    }

    .navbar-nav .nav-link:hover,
    .navbar-nav .nav-link:focus,
    .navbar-nav .dropdown.show > .nav-link {
      color: #ffffff !important;
      background: rgba(255, 255, 255, 0.08);
    }

    .navbar-nav .dropdown-menu {
      min-width: 100%;
      margin-top: 0.25rem;
      position: static;
      box-shadow: none;
      border-color: rgba(255, 255, 255, 0.16);
      background: rgba(15, 23, 42, 0.32);
    }

    .navbar-nav .dropdown-item {
      color: #e5f7ff;
      min-height: 48px;
    }

    .navbar-nav .dropdown-item:hover,
    .navbar-nav .dropdown-item:focus {
      background-color: rgba(7, 167, 225, 0.22);
      color: #ffffff;
    }

    .navbar-nav .dropdown-item.router-link-active,
    .navbar-nav .dropdown-item.router-link-exact-active {
      color: #7dd3fc;
      font-weight: 600;
      background-color: rgba(7, 167, 225, 0.18);
    }

    .navbar-nav .dropdown-toggle {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .navbar-nav .dropdown-menu.show {
      display: block;
    }

    .navbar-account {
      margin-top: 0.75rem;
      padding-top: 0.75rem;
      border-top: 1px solid rgba(255, 255, 255, 0.12);
    }

    .navbar-text.client-trade-name,
    .navbar-sucursal-label {
      color: #f8fafc !important;
    }

    .navbar-sucursal-selector {
      margin-top: 0.75rem;
      padding-top: 0.75rem;
      border-top: 1px solid rgba(255, 255, 255, 0.12);
      margin-right: 0 !important;
      flex-direction: column;
      align-items: stretch;
    }
  }
    
  </style>
  
